import type { FaireProductEntity } from "../../entity_types/product";

export const p_8auuhgvbzn: FaireProductEntity = {
  token: "p_8auuhgvbzn",
  type: "product",
  name: "Gardenia Hand Cream 1 oz – Flower Market",
  brandToken: "b_hcbhgx8v9w",
  brandName: "123 Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/28259ca70686d4bd7822abf1806f641221ce2d1fd6a66bfeee62c3c86dab263a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bbfaa060f4ccc74269322782b69cb5e63cc478166694a55c015f56ca7093edfa.png",
  ],
  priceDollars: 2.74,
  description:
    "Enjoy the delicate floral scent of our Gardenia Hand Cream, a 1 oz blend designed to nourish and hydrate your hands. Formulated with rich, skin-loving ingredients, this cream absorbs quickly, leaving your hands feeling soft, smooth, and beautifully scented.\n\nCrafted with nourishing ingredients:\nShea Butter and Cocoa Butter: Provide deep hydration and repair dry skin.\nJojoba and Macadamia Oils: Lock in moisture and improve skin texture.\nAloe Vera and Lemon Extracts: Soothe and revitalize tired hands.\n*testers are available\n\n",
  tags: [],
  msrpDollars: 5.48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:38.342Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
